// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import reviewsReducer from './reviewsSlice';
import guideContactReducer from './guideContactSlice'

const store = configureStore({
  reducer: {
    reviews: reviewsReducer,
    guideContacts: guideContactReducer,
  },
});

export default store;
